/* eslint-disable jsx-a11y/no-autofocus -- the code is the only field */
import React from 'react';
import { Input } from '@/components/Form';
import { VerificationChallenge } from '@/hooks/useVerificationChallenge';

type CodeInputProps = Pick<
  React.ComponentProps<typeof Input>,
  'id' | 'aria-label' | 'mt' | 'padding' | 'width'
> & {
  challenge: VerificationChallenge;
};

const CodeInput: React.FC<CodeInputProps> = ({ challenge, ...props }) => (
  <Input
    {...props}
    ref={challenge.input}
    autoFocus
    autoComplete="one-time-code"
    inputMode="numeric"
    pattern="[0-9]*"
    maxLength={6}
    placeholder="6-digit code"
    value={challenge.code}
    disabled={!!challenge.pending}
    onChange={(event) => challenge.setCode(event.target.value)}
  />
);

export default CodeInput;
